export const meta = {
  id: 'M08',
  slug: 'analisar-evidencia',
  title: 'Como analisar uma Evidência',
  description: 'Avalie o que a Evidência realmente demonstra sobre aplicação prática, comportamento ou resultado do mentorado.',
  profile: 'mentor',
  category: 'evidencias',
  type: 'task',
  status: 'published',
  order: 290,
  keywords: ['evidência', 'avaliar', 'analisar', 'mentorado', 'prática', 'resultado', 'habilidade', 'atitude'],
  previous: 'M07',
  next: 'M09',
  related: ['A11', 'M04', 'M13'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como analisar uma Evidência

Uma Evidência deve ajudar a demonstrar aplicação prática, comportamento ou resultado relacionado ao desenvolvimento do mentorado.

## Como analisar

<Steps>
  <Step title="Abra a Evidência">
    Consulte descrição, link e demais informações registradas pelo mentorado.
  </Step>
  <Step title="Entenda o contexto">
    Relacione a Evidência à competência, objetivo, atividade ou ação que ela pretende demonstrar.
  </Step>
  <Step title="Avalie o que foi demonstrado">
    Observe se há aplicação real, especificidade, comportamento observável ou resultado concreto.
  </Step>
  <Step title="Registre sua análise">
    Utilize a ação de validação ou avaliação disponível e dê um retorno útil quando aplicável.
  </Step>
</Steps>

## Perguntas úteis

- O que essa Evidência demonstra na prática?
- O registro é específico o suficiente?
- Há resultado ou comportamento observável?
- Ela se relaciona à competência que está sendo desenvolvida?
- A Evidência mostra Conhecimento, Habilidade, Atitude ou uma combinação deles?

<Callout type="warning">
  Não valide uma Evidência apenas porque existe um anexo ou link. O valor está no que ela demonstra sobre o desenvolvimento real.
</Callout>

<HelpImage alt="Evidência recebida para análise pelo Mentor" pendingId="M08.1" />
<HelpImage alt="Área de avaliação de Evidência pelo Mentor" pendingId="M08.2" />
